import { render, staticRenderFns } from "./LessonPage.vue?vue&type=template&id=34938bba&scoped=true"
import script from "./LessonPage.vue?vue&type=script&lang=js"
export * from "./LessonPage.vue?vue&type=script&lang=js"
import style0 from "./LessonPage.vue?vue&type=style&index=0&id=34938bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34938bba",
  null
  
)

export default component.exports